import accounting from 'accounting';
import cdn from '@23g/cdn-helper';
import Vue from 'vue';
import { mapState } from 'vuex';

const {
    decimal,
    precision,
    symbol,
    thousand,
} = window.Laravel.currency;

accounting.settings = {
    currency: {
        decimal,
        precision,
        symbol,
        thousand,
        format: {
            pos: '%s %v',
            neg: '%s -%v',
            zero: '%s %v',
        },
    },
    number: {
        decimal,
        precision,
        thousand,
    },
};

Vue.mixin({
    filters: {
        currency: (cents, inputSymbol = symbol) => (
            accounting.formatMoney(cents / 100, {
                symbol: inputSymbol,
                precision,
            })
        ),

        number(number) {
            const inputPrecision = number % 1 === 0 ? 0 : precision;

            return accounting.formatNumber(number, {
                precision: inputPrecision,
            });
        },
    },
    data: () => ({
        csrfToken: window.Laravel.csrfToken,
        isLoggedIn: window.Laravel.isLoggedIn,
        isBusinessUser: window.Laravel.isBusinessUser,
    }),
    computed: {
        ...mapState('global', [
            'isMobile',
            'showFilters',
            'showImageModal',
        ]),
    },
    methods: {
        formatCurrency(cents, inputSymbol = symbol) {
            return accounting.formatMoney(cents / 100, {
                symbol: inputSymbol,
                precision,
            });
        },

        formatNumber(number) {
            const inputPrecision = number % 1 === 0 ? 0 : precision;

            return accounting.formatNumber(number, {
                precision: inputPrecision,
            });
        },
        generateImageSizes(src, sizes) {
            return sizes.map((size) => {
                const image = cdn(src, size);

                if (size[0] === 'h' || size[0] === 'w') {
                    return `${image} ${size.substring(1)}w`;
                }
                return `${image} ${size.split('x')[0]}w`;
            }).join(', ');
        },
        route: window.route ? window.route : {},
    },
});
